import { createAction, props } from "@ngrx/store";
import {
  LicenseEntity,
  LicenseLimitExceededVO
} from "@youm-front/license/domain";

export const loadLicense = createAction("[License] Load License");
export const loadLicenseSuccess = createAction(
  "[License] Load License Success",
  props<{ license: LicenseEntity }>()
);
export const loadLicenseFailure = createAction(
  "[License] Load License Failure",
  props<{ error: string }>()
);

export const licenseLimitMaxLiveDuration = createAction(
  "[License] Limit Max Live Duration",
  props<{ licenseLimitExceededVO: LicenseLimitExceededVO }>()
);
